import {
    GET_ROUNDS,
    GET_ROUNDS_SUCCESS,
    ADD_ROUND,
    ADD_ROUND_SUCCESS,
    UPDATE_ROUND,
    UPDATE_ROUND_SUCCESS,
    DELETE_ROUND,
    DELETE_ROUND_SUCCESS,
} from './constants.js';

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getRounds = (id) => ({
    type: GET_ROUNDS,
    id
});

/**
 *
 * @param rounds
 * @returns {{rounds: *, type: string}}
 */
const getRoundsSuccess = rounds => ({
    type: GET_ROUNDS_SUCCESS,
    rounds
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const addRound = (formData) => ({
    type: ADD_ROUND,
    formData
});

/**
 *
 * @param rounds
 * @returns {{type: string, rounds: *}}
 */
const addRoundSuccess = (rounds) => ({
    type: ADD_ROUND_SUCCESS,
    rounds
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const updateRound = (formData) => ({
    type: UPDATE_ROUND,
    formData
});

/**
 *
 * @param rounds
 * @returns {{type: string, rounds: *}}
 */
const updateRoundSuccess = (rounds) => ({
    type: UPDATE_ROUND_SUCCESS,
    rounds
});

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteRound = (id) => ({
    type: DELETE_ROUND,
    id
});

/**
 *
 * @param rounds
 * @returns {{rounds: *, type: string}}
 */
const deleteRoundSuccess = rounds => ({
    type: DELETE_ROUND_SUCCESS,
    rounds
});

export {
    getRounds,
    getRoundsSuccess,
    addRound,
    addRoundSuccess,
    updateRound,
    updateRoundSuccess,
    deleteRound,
    deleteRoundSuccess
};